module.exports = __webpack_public_path__ + "img/code.5b5a2beb.png";